"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackPagination = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
const trackPagination = (clickElement, clickValue, clickUrl) => {
    const bookingEvent = {
        event: 'JS_Event',
        eventData: {
            eventName: enums_1.GA4EventName.ClickPagination,
            feature_category: enums_1.GA4FeatureCategory.ProviderList,
            click_element: clickElement,
            click_value: clickValue,
            click_url: clickUrl,
        },
    };
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)(bookingEvent);
};
exports.trackPagination = trackPagination;
//# sourceMappingURL=trackPagination.js.map